import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "question-inner" }
const _hoisted_2 = {
  key: 1,
  class: "question-title"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QuestionTimer = _resolveComponent("QuestionTimer")
  const _component_QuestionVerticalSelect = _resolveComponent("QuestionVerticalSelect")
  const _component_ScrollBar = _resolveComponent("ScrollBar")
  const _component_Collapse = _resolveComponent("Collapse")

  return (_openBlock(), _createBlock(_component_Collapse, {
    open: !!$props.question,
    class: "question"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        ($options.on_skip)
          ? (_openBlock(), _createBlock(_component_QuestionTimer, {
              key: 0,
              ref: "timer",
              question: $props.question,
              onAnswerAi: _cache[0] || (_cache[0] = $event => ($options.onAnswer($options.on_skip)))
            }, null, 8 /* PROPS */, ["question"]))
          : _createCommentVNode("v-if", true),
        ($options.title)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString($options.title), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_ScrollBar, {
          class: "scrollbar",
          "max-height": "25rem",
          fade: ""
        }, {
          default: _withCtx(() => [
            ($options.type === 'vertical_select')
              ? (_openBlock(), _createBlock(_component_QuestionVerticalSelect, {
                  key: 0,
                  options: $options.items,
                  onAnswerAi: $options.onAnswer
                }, null, 8 /* PROPS */, ["options", "onAnswerAi"]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" <QuestionButtons v-else-if=\"type === 'buttons'\" :options=\"items\" @prompt=\"onPrompt\"/>\n        <QuestionMultiselect v-else-if=\"type === 'multiselect'\" :options=\"items\" :skip=\"skip\" @prompt=\"onPrompt\"/>\n        <QuestionSelect v-else-if=\"type === 'select'\" :options=\"items\" :skip=\"skip\" @prompt=\"onPrompt\"/>\n        <QuestionText v-else-if=\"type === 'text'\" :query=\"chat_query\" :skip=\"skip\" :skip-all=\"skip_all\" @prompt=\"onPrompt\"/>\n        <QuestionProfileSelect v-else-if=\"type === 'profile_select'\" :options=\"items\" :skip=\"skip\" :skip-all=\"skip_all\" @prompt=\"onPrompt\"/> ")
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["open"]))
}